import { render, staticRenderFns } from "./Sectors.vue?vue&type=template&id=7a0251dd&scoped=true&"
import script from "./Sectors.vue?vue&type=script&lang=ts&"
export * from "./Sectors.vue?vue&type=script&lang=ts&"
import style0 from "./Sectors.vue?vue&type=style&index=0&id=7a0251dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0251dd",
  null
  
)

export default component.exports